var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFD7-Grundlagen:-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-652.000000, -2970.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atom/icon/16px/sex/male",
    transform: "translate(652.000000, 2970.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,6.5 L13,3 M6,14 C8.209139,14 10,12.209139 10,10 C10,7.790861 8.209139,6 6,6 C3.790861,6 2,7.790861 2,10 C2,12.209139 3.790861,14 6,14 Z",
    id: "Combined-Shape",
    stroke: "#242F38",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    stroke: "#242F38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(11.500000, 4.500000) rotate(90.000000) translate(-11.500000, -4.500000) ",
    points: "9 7 9 2 14 2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.500a7982c9627da454e9967dbc1c3f57.svg";
export { ForwardRef as ReactComponent };